import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsBitdefenderComponent } from './simple-icons-bitdefender.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsBitdefenderComponent ],
    exports:      [ SimpleIconsBitdefenderComponent ],
    bootstrap:    []
})
export class SimpleIconsBitdefenderModule {}
